import { Trans } from "@lingui/macro";
import { UiTypography } from "@smp/ui";
import {
  domScriptInjectAsync,
  REACT_APP__ENVIRONMENT,
  REACT_APP__GOOGLE_ANALYTICS_ID,
} from "@smp/utils";
import { useSnackbar } from "notistack";
import { useEffect } from "react";

import { useContextApp } from "../app";

export const ProviderGA = () => {
  const {
    state: {
      me: { id: meId, is_staff: meIsStaff },
    },
  } = useContextApp();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    (async () => {
      if (!meId) return;
      if (meIsStaff) return;

      if (REACT_APP__GOOGLE_ANALYTICS_ID) {
        try {
          await domScriptInjectAsync(
            "https://www.google-analytics.com/analytics.js",
            "head",
          );
          window.ga =
            window.ga ||
            function () {
              (window.ga.q = window.ga.q || []).push(arguments);
            };
          window.ga.l = +new Date();
          if (REACT_APP__ENVIRONMENT === "production") {
            window.ga("create", REACT_APP__GOOGLE_ANALYTICS_ID, "auto", {
              cookieName: "gav1",
              name: "v1",
            });
            window.ga("v1.send", "pageview");
            window.ga("v1.set", "&uid", meId);
          }
          if (REACT_APP__ENVIRONMENT === "staging") {
            window.ga("create", REACT_APP__GOOGLE_ANALYTICS_ID, "auto", {
              cookieName: "gav3",
              name: "v3",
            });
            window.ga("v3.send", "pageview");
            window.ga("v3.set", "&uid", meId);
          }
        } catch (error) {
          enqueueSnackbar(
            <UiTypography>
              <Trans>
                There has been an error loading the{" "}
                <strong>Google Tag Manager</strong> script
              </Trans>
            </UiTypography>,
            { variant: "warning" },
          );
        }
      }
    })();
  }, [enqueueSnackbar, meId, meIsStaff]);
  return null;
};
